import Amplify from '@aws-amplify/auth';

// window.LOG_LEVEL='DEBUG' // useful for authentication debugging purpose
Amplify.configure({
  Auth: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_UrNAATAy8',
    userPoolWebClientId: '46v7bhiaph41srlc78i7ukgcpa',
  },
});
